import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { APP_CONFIG } from '../../api/config';
import { IAppConfig } from '../../store/interfaces';

declare let $BV: any;

@Component({
  selector: 'bv-reviews',
  templateUrl: './bv-reviews.component.html',
  styleUrls: ['./bv-reviews.component.scss'],
  encapsulation: ViewEncapsulation.None
})
// DO NOT load this component as part of the components module
export class BvReviewsComponent implements OnInit {

  @Input('bv-code')
  public bvCode: string;

  @Input('hotel-code')
  public hotelCode: string;

  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
              @Inject(DOCUMENT) private document) {}

  ngOnInit() {
    const bvApiJs = this.document.createElement('script');
    bvApiJs.type = 'text/javascript';
    bvApiJs.async = true;
    bvApiJs.defer = true;
    bvApiJs.src = this.appConfig.bvAPI.replace('{bvCode}', this.bvCode);
    bvApiJs.addEventListener('load', _ => {
      const submitReviewURL = `${window.location.origin}${window.location.pathname}`;

      if ($BV !== null && $BV !== undefined) {
        $BV.configure('global', {submissionContainerUrl: submitReviewURL});

        $BV.ui('rr', 'show_reviews', {
          productId: this.hotelCode
        });
      }
    });

    this.document.getElementById('bvApiJs').appendChild(bvApiJs);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/bv-reviews/bv-reviews.component.ts